import { IInfo } from '../../types';
import iconPng from './icon.png';
import iconSvg from './icon.svg';
import logoPng from './logo.png';
import logoSvg from './logo.svg';

const name = 'Jigsaw Nation';

const tagline = 'The best place to buy jigsaw puzzles online.';

const funTagline = 'Small pieces, big picture.';

export const info: IInfo = {
  emails: {
    contact: 'hello@jigsawnation.com',
    sales: 'sales@jigsawnation.com',
  },
  socials: [
    { name: 'Instagram', url: 'https://www.instagram.com/jigsawnationdotcom/' },
  ],
  phone: {
    india: '+91 87998 02963',
    uae: '+971541627353',
  },
  entity: {
    india: { legalEntity: 'Band of Capes Pvt. Ltd.' },
    uae: { legalEntity: 'Mantiq Corp Fz LLE' },
  },
  store: {
    address: 'Bored Game Company, Pune, India',
    gmaps: 'https://maps.app.goo.gl/qPdTE4o2BB36ijHeA',
    reviewUrl: 'https://g.page/r/CTKZ0vOf84lqEBM/review',
  },
  name,
  tagline,
  funTagline,
  logo: {
    svg: logoSvg,
    png: logoPng,
  },
  icon: {
    svg: iconSvg,
    png: iconPng,
  },
  parent: null,
  url: 'https://in.jigsawnation.com/',
};
